var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableTennisBat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "table-tennis-bat_svg__nc-icon-wrapper",
    strokeLinecap: "square",
    strokeWidth: 2,
    fill: "none",
    stroke: "gray",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    strokeLinecap: "butt",
    d: "M8.23 12.23l11.538 11.538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.532 9.459a9.2 9.2 0 00-2.263-3.725c-3.9-3.9-10.554-3.589-14.849.707A10.888 10.888 0 009.1 19.082l-6.211 4.54a2 2 0 00-.234 3.029l2.7 2.7a2 2 0 003.028-.234l4.543-6.209a10.435 10.435 0 009.159.092"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-color": "color-2",
    cx: 27,
    cy: 17,
    r: 4
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHRpdGxlPnRhYmxlIHRlbm5pcyBiYXQ8L3RpdGxlPjxnIGNsYXNzPSJuYy1pY29uLXdyYXBwZXIiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIHN0cm9rZS1saW5lam9pbj0ibWl0ZXIiIHN0cm9rZS13aWR0aD0iMiIgZmlsbD0iIzgwODA4MCIgc3Ryb2tlPSIjODA4MDgwIj48bGluZSBkYXRhLWNhcD0iYnV0dCIgeDE9IjguMjMiIHkxPSIxMi4yMyIgeDI9IjE5Ljc2OCIgeTI9IjIzLjc2OCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjODA4MDgwIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJidXR0Ii8+IDxwYXRoIGQ9Ik0yOC41MzIsOS40NTlhOS4yLDkuMiwwLDAsMC0yLjI2My0zLjcyNWMtMy45LTMuOS0xMC41NTQtMy41ODktMTQuODQ5LjcwN0ExMC44ODgsMTAuODg4LDAsMCwwLDkuMSwxOS4wODJsLTYuMjExLDQuNTRhMiwyLDAsMCwwLS4yMzQsMy4wMjlsMi43LDIuN2EyLDIsMCwwLDAsMy4wMjgtLjIzNGw0LjU0My02LjIwOUExMC40MzUsMTAuNDM1LDAsMCwwLDIyLjA4NSwyMyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjODA4MDgwIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz4gPGNpcmNsZSBkYXRhLWNvbG9yPSJjb2xvci0yIiBjeD0iMjciIGN5PSIxNyIgcj0iNCIgZmlsbD0ibm9uZSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+PC9nPjwvc3ZnPg==";
export { SvgTableTennisBat as ReactComponent };